
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AbrangenciasComponent from '@/components/AbrangenciasComponent.vue';
import { adminStore, bucketStore, companyStore, mainStore, parceriaStore } from '@/store';

@Component({
  components: {
    AbrangenciasComponent,
  },
})
export default class AddParceria extends Vue {
  @Prop({ default: false }) readonly allowEdit;
  @Watch('dialog', { immediate: true })
  async onOpenDialog(isOpen) {
    if (isOpen) {
      if (this.parceria.id) {
        this.abrangencia = this.parceria.coverage;
        await bucketStore.getFilesByID({
          bucket_name: 'parceria',
          file_id: String(this.parceria.id),
        });
        if (this.files.length === 0) {
          await bucketStore.getFilesByBucketName('parceria');
        }
        await this.setSrcs();
      } else {
        this.resetParceria();
      }
    } else {
      this.resetParceria();
    }
  }

  public parceria: any = {
    id: null,
    responsavel_knn: null,
    title: null,
    contato_parceria: null,
    forma_contato: null,
    contato_email: null,
    contato_fone: null,
    description: null,
    description_site: null,
    site: null,
    coverage: null,
  };

  public isLoading = true;

  public resetParceria() {
    this.parceria = {
      id: null,
      responsavel_knn: null,
      title: null,
      contato_parceria: null,
      forma_contato: null,
      contato_email: null,
      contato_fone: null,
      description: null,
      description_site: null,
      site: null,
      coverage: null,
    };
    this.abrangencia = {};
    this.photoSrc = null;
    this.contratoSrc = null;
  }

  public photoSrc: null | string = null;

  public contratoSrc: null | string = null;

  public materialApoioSrc: null | string = null;

  public abrangencia: any = {};

  public name = 'Register';

  public contrato: any = null;

  public materialApoio: any = null;

  public photo: any = null;

  public dialog = false;

  public statusOptions = [
    { id: 0, text: 'Proposta de parceria' },
    { id: 1, text: 'Parceria em negociação' },
    { id: 2, text: 'Parceria vigente' },
  ];

  public statusObservacao: null | string = null;

  public id: any = undefined;

  get franchisingName() {
    return mainStore.franchisingName;
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  get files() {
    return bucketStore.files;
  }

  get companies() {
    return companyStore.companies;
  }

  get users() {
    return adminStore.usersFranchising;
  }

  get isDisabled() {
    if (this.parceria.id) {
      return (!this.contrato && !this.contratoSrc) || (!this.photo && !this.photoSrc);
    }
    return (
      !this.parceria.responsavel_knn ||
      !this.parceria.title ||
      !this.parceria.contato_parceria ||
      !this.parceria.forma_contato ||
      !this.parceria.contato_email ||
      !this.parceria.contato_fone ||
      !this.parceria.description ||
      !this.parceria.description_site ||
      // !this.site ||
      Object.keys(this.abrangencia).length !== 3 ||
      (!this.contrato && !this.contratoSrc) ||
      (!this.photo && !this.photoSrc)
    );
  }

  public async salvarParceria() {
    this.isLoading = true;
    // CRIANDO OBJETO QUE SERÁ ENVIADO PARA BACKEND
    const payload: any = {
      title: this.parceria.title,
      description: this.parceria.description,
      description_site: this.parceria.description_site,
      coverage: this.parceria.coverage,
      responsavel_knn: this.parceria.responsavel_knn,
      forma_contato: this.parceria.forma_contato,
      contato_parceria: this.parceria.contato_parceria,
      contato_email: this.parceria.contato_email,
      contato_fone: this.parceria.contato_fone,
      site: this.parceria.site,
      franchising_id: this.currentUser.franchising_id,
    };

    // CHAMAR FUNCAO QUE SE COMUNICA COM BACKEND
    if (!this.parceria.id) {
      this.parceria = await parceriaStore.createParceria(payload);
    } else {
      payload.id = this.parceria.id;
      this.parceria = await parceriaStore.updateParceria(payload);
    }

    // UPLOAD DO CONTRATO
    if (this.contrato) {
      await bucketStore.deleteFromBucketByTableName({
        bucket_name: 'parceria',
        table_name: 'parceria-contrato',
        type: '1',
        id: this.parceria.id,
      });
      await bucketStore.uploadFile({
        bucket_name: 'parceria',
        file_name: 'parceria-contrato',
        file_id: String(this.parceria.id),
        file: this.contrato,
      });
    }

    // UPLOAD DO MATERIAL DE APOIO
    if (this.materialApoio) {
      await bucketStore.deleteFromBucketByTableName({
        bucket_name: 'parceria',
        table_name: 'parceria-materialApoio',
        type: '1',
        id: this.parceria.id,
      });
      await bucketStore.uploadFile({
        bucket_name: 'parceria',
        file_name: 'parceria-materialApoio',
        file_id: String(this.parceria.id),
        file: this.materialApoio,
      });
    }

    // UPLOAD DA FOTO
    if (this.photo) {
      await bucketStore.deleteFromBucketByTableName({
        bucket_name: 'parceria',
        table_name: 'parceria-mockup',
        type: '1',
        id: this.parceria.id,
      });
      await bucketStore.uploadFile({
        bucket_name: 'parceria',
        file_name: 'parceria-mockup',
        file_id: String(this.parceria.id),
        file: this.photo,
      });
    }
    this.$emit('updateList');
    this.isLoading = false;
    this.dialog = false;
  }

  public geraPhotoSrc() {
    const photo = this.photo;
    const src = URL.createObjectURL(photo);
    this.photoSrc = src;
  }

  public removePhoto() {
    this.photoSrc = null;
    this.photo = null;
  }

  public async openContrato() {
    let url = '';
    if (!this.contratoSrc) {
      url = URL.createObjectURL(this.contrato);
    } else {
      url = this.contratoSrc;
    }
    let a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = 'contrato';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public async removeContrato() {
    this.$swal({
      title: 'Remover contrato?',
      icon: 'warning',
      html: `O arquivo não poderá ser recuperado`,
      showCancelButton: true,
      showConfirmButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.contrato = null;
        await bucketStore.deleteFromBucketByTableName({
          bucket_name: 'parceria',
          table_name: 'parceria-contrato',
          id: this.parceria.id,
          type: '1',
        });
      }
    });
    await bucketStore.getFilesByID({
      bucket_name: 'parceria',
      file_id: this.parceria.id,
    });
    await this.setSrcs();
  }

  public async openMaterialApoio() {
    let url = '';
    if (!this.materialApoioSrc) {
      url = URL.createObjectURL(this.materialApoio);
    } else {
      url = this.materialApoioSrc;
    }
    let a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.download = 'materialApoio';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public async removeMaterialApoio() {
    this.$swal({
      title: 'Remover material de apoio?',
      icon: 'warning',
      html: `O arquivo não poderá ser recuperado`,
      showCancelButton: true,
      showConfirmButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.contrato = null;
        await bucketStore.deleteFromBucketByTableName({
          bucket_name: 'parceria',
          table_name: 'parceria-materialApoio',
          id: this.parceria.id,
          type: '1',
        });
      }
    });
    await bucketStore.getFilesByID({
      bucket_name: 'parceria',
      file_id: this.parceria.id,
    });
    await this.setSrcs();
  }

  public async receiveAbrangencia(abrangencia) {
    this.abrangencia = abrangencia;
    this.parceria.coverage = abrangencia;
  }

  public async openInput(n) {
    const el: any = document.getElementById(`fileInput-${n}`);
    el.click();
  }

  public async openPhotoPreview() {
    const el: any = document.getElementById('photoInput');
    el.click();
  }

  public setSrcs() {
    const aux = this.files.find(
      (f) =>
        f['blob']['id'] == this.parceria.id &&
        (f['blob']['full_name'].toLowerCase().includes('mockup') ||
          f['blob']['full_name'].toLowerCase().includes('logo'))
    );
    if (aux) {
      this.photoSrc = aux['download_url'];
    }
    const aux2 = this.files.find(
      (f) => f['blob']['id'] == this.parceria.id && f['blob']['full_name'].toLowerCase().includes('contrato')
    );
    if (aux2) {
      this.contratoSrc = aux2['download_url'];
    }
    const aux3 = this.files.find(
      (f) => f['blob']['id'] == this.parceria.id && f['blob']['full_name'].toLowerCase().includes('materialApoio')
    );
    if (aux3) {
      this.contratoSrc = aux3['download_url'];
    }
  }

  // MOUNTED -> Função que roda toda a vez que a página atualiza
  public async mounted() {
    await companyStore.getCompanies({ is_franchise: true, is_active: true });

    this.isLoading = false;
  }
}
